import { useCallback, useState } from 'react'

import { useRive } from '@rive-app/react-canvas'

import Animation from './button.riv?url'
import { MidYearSaleDialog } from './dialog'

export const MidYearSaleDialogTrigger = () => {
  const [isDialogOpen, setDialogOpen] = useState(false)

  const { rive, RiveComponent } = useRive({
    src: Animation,
    stateMachines: 'State Machine 1',
    animations: ['Shine', 'Timeline 3', 'Timeline 2', 'Idle', 'Stroke shine'],
    autoplay: true,
  })

  const handleDialogClose = useCallback(() => {
    setDialogOpen(false)
  }, [])

  return (
    <div
      onClick={() => setDialogOpen(true)}
      className="relative h-10 w-[187px] cursor-pointer overflow-hidden"
      onMouseEnter={() => rive && rive.play()}
    >
      {/** Without this the onClick event doesn't trigger on parent element on mobile */}
      <div className="absolute inset-0 z-10 bg-transparent sm:hidden" />
      <RiveComponent
        className="absolute h-[67px] w-[257px] [&>canvas]:-ml-[34px] [&>canvas]:-mt-[5px]"
        height={67}
        width={187}
      />
      <MidYearSaleDialog
        isOpen={isDialogOpen}
        onClose={handleDialogClose}
      />
    </div>
  )
}
